export default {
  company: "公司",
  share_holder: "股东",
  super_senior: "超资深代理",
  senior: "资深代理",
  master: "总代理",
  agent: "代理",
  member: "会员",

  account_id: "用户名",
  action: "操作",
  available_credit: "可用信用",
  active: "活跃",
  account_balance: "账号余额",
  agent_credit: "代理信用",
  authority: "权限",
  account_information: "账号信息",
  account_list: "账号列表",
  audit_by: "审核于",
  add_account: "添加账号",
  add_sub_account: "添加子账号",
  authority_option: "权限选项",
  account: "账号",
  access_log: "访问日志",
  account_log: "账号日志",
  account_details: "账号详情",
  action_by: "操作于",
  away_team_name: "客队名称",
  amount: "金额",
  account_before_balance: "账号前余额",
  account_after_balance: "账号后余额",
  active_bet_list: "活跃投注列表",
  agent_win_all: "代理全赢",
  agent_win_half: "代理赢半",
  agent_lose_all: "代理全输",
  agent_lose_half: "代理输半",
  accumulate_win: "累积赢盘",
  add_sub: "添加子账号",
  account_type: "账号类型",
  account_pt: "账号PT（持仓）",
  account_min: "账号最低限额",
  away_score: "客队成绩",
  add_secondary_full: "添加辅助账号",
  accumulate_balance: "累积余额",
  away: "客队",
  aa: "客队上半场 ； 客队全场",
  ad: "客队上半场 ； 打和全场",
  ah: "客队上半场 ； 主队全场",
  anb: "获胜球队",
  all: "全部",
  account_existed: "账号已存在",
  account_not_existed: "账号不存在",
  account_status: "账号状态",
  account_block: "账号已封锁",
  account_unblock: "账号已解锁",
  add_secondary: "添加辅助账号",
  agent_bulk: "代理（批量）",
  abandoned: "弃赛",
  account_list_alert: "玩家警报",
  adjustment: "调整",

  balance: "余额",
  bet: "投注",
  block: "封锁",
  blocked: "已封锁",
  back: "返回",
  bet_limit: "投注限额",
  basketball: "篮球",
  baseball: "棒球",
  bet_limit_log: "投注限额日志",
  browser_agent: "代理游览",
  bet_limit_packages: "投注限额配套",
  ball: "球",
  bet_count: "投注计算",
  bet_type: "投注类型",
  bl: "投注限额",
  basketball_min_bet: "@:ui.basketball @:ui.min_bet",
  basketball_max_bet: "@:ui.basketball @:ui.max_bet",
  basketball_max_per_match: "@:ui.basketball @:ui.max_per_match",
  baseball_min_bet: "@:ui.baseball @:ui.min_bet",
  baseball_max_bet: "@:ui.baseball @:ui.max_bet",
  baseball_max_per_match: "@:ui.baseball @:ui.max_per_match",
  bet_list: "投注列表",
  bet_list_4d: "投注列表 4D",
  bet_list_esports2: "投注列表 电子竞技2",
  bs: "两者皆不得分",

  credit: "信用",
  cm: "佣金",
  close: "关闭",
  cancel: "取消",
  continue: "继续",
  created_on: "创建于",
  copy_and_create: "复制与创建",
  copy: "复制",
  confirm_password: "确认密码",
  confirm_security_code: "确认安全码",
  contact_phone: "电话",
  contact_email: "电邮",
  cash_balance: "现金余额",
  currency: "货币",
  credit_limit: "信用限额",
  credit_balance: "信用/余额",
  commission: "佣金",
  correct_score: "波胆",
  correct_score_bl: "波胆 (@:ui.soccer)",
  commission_log: "佣金日志",
  current_balance: "当前余额",
  cancelled_bet_list: "取消投注列表",
  category: "类别",
  copy_to_bottom: "复制至底层",
  comm_sportsbook_hdp_a: "让球 A",
  comm_sportsbook_hdp_b: "让球 B",
  comm_sportsbook_hdp_c: "让球 C",
  comm_sportsbook_hdp_d: "让球 D",
  comm_sportsbook_hdp_e: "让球 E",
  comm_sportsbook_hdp_f: "让球 F",
  comm_sportsbook_hdp_g: "让球 G",
  comm_sportsbook_hdp_h: "让球 H",
  comm_sportsbook_hdp_i: "让球 I",
  comm_sportsbook_hdp_j: "让球 J",
  comm_sportsbook_1x2: "独赢",
  comm_sportsbook_others: "其他",
  comm_sportsbook_hdp_packages: "让球配套",
  comm_slots: "老虎机",
  comm_casino: "真人娱乐场",
  comm_lotto: "乐透",
  comm_keno: "奇乐",
  comm_cockfight: "电子竞技2",
  comm_lottery_1d: "彩票 1D",
  comm_lottery_2d: "彩票 2D",
  comm_lottery_3d: "彩票 3D",
  comm_lottery_4d: "彩票 4D",
  comm_tournament: "Tournament",
  completed: "已完成",
  clean_sheet: "零失球",
  cockfight: "电子竞技2",
  esports2: "电子竞技2",
  cockfight_bet_limit_packages: "电子竞技2投注限额配套",
  combination: "组合",
  cs_min_bet: "@:ui.correct_score @:ui.min_bet",
  cs_max_bet: "@:ui.correct_score @:ui.max_bet",
  cs_max_per_match: "@:ui.correct_score @:ui.max_per_match",

  combine: {
    bet_limit_A: "投注 A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_B: "投注 B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_C: "投注 C (@:ui.min = 20 @:ui.max = 1000)",
    bet_limit_D: "投注 D (@:ui.min = 200 @:ui.max = 5000)",
    bet_limit_E: "投注 E (@:ui.min = 500 @:ui.max = 10000)",
    bet_limit_F: "投注 F (@:ui.min = 500 @:ui.max = 20000)",
    bet_limit_G: "投注 G (@:ui.min = 500 @:ui.max = 30000)",

    // bet_limit_AUDA: "投注 A (@:ui.min = 1 @:ui.max = 100)",
    // bet_limit_AUDB: "投注 B (@:ui.min = 1 @:ui.max = 125)",
    // bet_limit_AUDC: "投注 C (@:ui.min = 1 @:ui.max = 400)",
    // bet_limit_AUDD: "投注 D (@:ui.min = 5 @:ui.max = 1,500)",
    // bet_limit_AUDE: "投注 E (@:ui.min = 5 @:ui.max = 2,500)",
    // bet_limit_AUDF: "投注 F (@:ui.min = 5 @:ui.max = 5,000)",
    // bet_limit_AUDG: "投注 G (@:ui.min = 5 @:ui.max = 10,000)",

    bet_limit_KRWA: "投注 A (@:ui.min = 1,500 @:ui.max = 200,000)",
    bet_limit_KRWB: "投注 B (@:ui.min = 2,000 @:ui.max = 200,000)",
    bet_limit_KRWC: "投注 C (@:ui.min = 2,000 @:ui.max = 400,000)",
    bet_limit_KRWD: "投注 D (@:ui.min = 4,000 @:ui.max = 800,000)",
    bet_limit_KRWE: "投注 E (@:ui.min = 4,000 @:ui.max = 2,000,000)",
    bet_limit_KRWF: "投注 F (@:ui.min = 4,000 @:ui.max = 4,000,000)",
    bet_limit_KRWG: "投注 G (@:ui.min = 4,000 @:ui.max = 6,000,000)",

    bet_limit_CNYA: "投注 A (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_CNYB: "投注 B (@:ui.min = 10 @:ui.max = 1000)",
    bet_limit_CNYC: "投注 C (@:ui.min = 10 @:ui.max = 2000)",
    bet_limit_CNYD: "投注 D (@:ui.min = 20 @:ui.max = 5000)",
    bet_limit_CNYE: "投注 E (@:ui.min = 20 @:ui.max = 10000)",
    bet_limit_CNYF: "投注 F (@:ui.min = 400 @:ui.max = 20000)",
    bet_limit_CNYG: "投注 G (@:ui.min = 20 @:ui.max = 50000)",

    bet_limit_HKDA: "投注 A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_HKDB: "投注 B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_HKDC: "投注 C (@:ui.min = 20 @:ui.max = 1000)",
    bet_limit_HKDD: "投注 D (@:ui.min = 200 @:ui.max = 5000)",
    bet_limit_HKDE: "投注 E (@:ui.min = 500 @:ui.max = 10000)",
    bet_limit_HKDF: "投注 F (@:ui.min = 500 @:ui.max = 20000)",
    bet_limit_HKDG: "投注 G (@:ui.min = 500 @:ui.max = 30000)",

    bet_limit_SGDA: "投注 A (@:ui.min = 1 @:ui.max = 100)",
    bet_limit_SGDB: "投注 B (@:ui.min = 1 @:ui.max = 200)",
    bet_limit_SGDC: "投注 C (@:ui.min = 5 @:ui.max = 500)",
    bet_limit_SGDD: "投注 D (@:ui.min = 5 @:ui.max = 1,000)",
    bet_limit_SGDE: "投注 E (@:ui.min = 10 @:ui.max = 2,000)",
    bet_limit_SGDF: "投注 F (@:ui.min = 5 @:ui.max = 5,000)",
    bet_limit_SGDG: "投注 G (@:ui.min = 5 @:ui.max = 10,000)",
    
    bet_limit_VNDA: "投注 A (@:ui.min = 10 @:ui.max = 2,000)",
    bet_limit_VNDB: "投注 B (@:ui.min = 10 @:ui.max = 3,000)",
    bet_limit_VNDC: "投注 C (@:ui.min = 40 @:ui.max = 5,000)",
    bet_limit_VNDD: "投注 D (@:ui.min = 80 @:ui.max = 25,000)",
    bet_limit_VNDE: "投注 E (@:ui.min = 80 @:ui.max = 50,000)",
    bet_limit_VNDF: "投注 F (@:ui.min = 80 @:ui.max = 100,000)",
    bet_limit_VNDG: "投注 G (@:ui.min = 80 @:ui.max = 150,000)",
	
	  bet_limit_MYRA: "投注 A (@:ui.min = 1 @:ui.max = 500)",
    bet_limit_MYRB: "投注 B (@:ui.min = 5 @:ui.max = 500)",
    bet_limit_MYRC: "投注 C (@:ui.min = 10 @:ui.max = 1,000)",
    bet_limit_MYRD: "投注 D (@:ui.min = 10 @:ui.max = 2,500)",
    bet_limit_MYRE: "投注 E (@:ui.min = 100 @:ui.max = 5,000)",
    bet_limit_MYRF: "投注 F (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_MYRG: "投注 G (@:ui.min = 500 @:ui.max = 20,000)",
	
	  bet_limit_USDA: "投注 A (@:ui.min = 1 @:ui.max = 100)",
    bet_limit_USDB: "投注 B (@:ui.min = 1 @:ui.max = 125)",
    bet_limit_USDC: "投注 C (@:ui.min = 1 @:ui.max = 400)",
    bet_limit_USDD: "投注 D (@:ui.min = 5 @:ui.max = 1,500)",
    bet_limit_USDE: "投注 E (@:ui.min = 5 @:ui.max = 2,500)",
    bet_limit_USDF: "投注 F (@:ui.min = 5 @:ui.max = 5,000)",
    bet_limit_USDG: "投注 G (@:ui.min = 5 @:ui.max = 10,000)",
	
	  bet_limit_THBA: "投注 A (@:ui.min = 10 @:ui.max = 2,500)",
    bet_limit_THBB: "投注 B (@:ui.min = 50 @:ui.max = 5,000)",
    bet_limit_THBC: "投注 C (@:ui.min = 100 @:ui.max = 10,000)",
    bet_limit_THBD: "投注 D (@:ui.min = 100 @:ui.max = 50,000)",
    bet_limit_THBE: "投注 E (@:ui.min = 100 @:ui.max = 100,000)",
    bet_limit_THBF: "投注 F (@:ui.min = 100 @:ui.max = 200,000)",
    bet_limit_THBG: "投注 G (@:ui.min = 100 @:ui.max = 300,000)",
	
	  bet_limit_IDRA: "投注 A (@:ui.min = 5 @:ui.max = 1,000)",
    bet_limit_IDRB: "投注 B (@:ui.min = 20 @:ui.max = 1,500)",
    bet_limit_IDRC: "投注 C (@:ui.min = 20 @:ui.max = 3,000)",
    bet_limit_IDRD: "投注 D (@:ui.min = 25 @:ui.max = 15,000)",
    bet_limit_IDRE: "投注 E (@:ui.min = 25 @:ui.max = 30,000)",
    bet_limit_IDRF: "投注 F (@:ui.min = 25 @:ui.max = 60,000)",
    bet_limit_IDRG: "投注 G (@:ui.min = 25 @:ui.max = 100,000)",

    bet_limit_MMKA: "Limit A (@:ui.min = 1 @:ui.max = 200)",
    bet_limit_MMKB: "Limit B (@:ui.min = 2 @:ui.max = 200)",
    bet_limit_MMKC: "Limit C (@:ui.min = 2 @:ui.max = 500)",
    bet_limit_MMKD: "Limit D (@:ui.min = 2 @:ui.max = 1,000)",
    bet_limit_MMKE: "Limit E (@:ui.min = 4 @:ui.max = 2,000)",
    bet_limit_MMKF: "Limit F (@:ui.min = 4 @:ui.max = 5,000)",
    bet_limit_MMKG: "Limit G (@:ui.min = 4 @:ui.max = 10,000)",

    bet_limit_MMOA: "Limit A (@:ui.min = 1 @:ui.max = 200)",
    bet_limit_MMOB: "Limit B (@:ui.min = 2 @:ui.max = 200)",
    bet_limit_MMOC: "Limit C (@:ui.min = 2 @:ui.max = 500)",
    bet_limit_MMOD: "Limit D (@:ui.min = 2 @:ui.max = 1,000)",
    bet_limit_MMOE: "Limit E (@:ui.min = 4 @:ui.max = 2,000)",
    bet_limit_MMOF: "Limit F (@:ui.min = 4 @:ui.max = 5,000)",
    bet_limit_MMOG: "Limit G (@:ui.min = 4 @:ui.max = 10,000)",

    bet_limit_ARSA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_ARSB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_ARSC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_ARSD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_ARSE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_ARSF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_ARSG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_AUDA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_AUDB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_AUDC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_AUDD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_AUDE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_AUDF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_AUDG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_BDTA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_BDTB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_BDTC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_BDTD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_BDTE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_BDTF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_BDTG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_BNDA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_BNDB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_BNDC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_BNDD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_BNDE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_BNDF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_BNDG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_BRLA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_BRLB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_BRLC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_BRLD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_BRLE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_BRLF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_BRLG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_EURA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_EURB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_EURC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_EURD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_EURE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_EURF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_EURG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_GOOA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_GOOB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_GOOC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_GOOD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_GOOE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_GOOF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_GOOG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_INRA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_INRB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_INRC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_INRD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_INRE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_INRF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_INRG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_JPYA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_JPYB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_JPYC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_JPYD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_JPYE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_JPYF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_JPYG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_NPRA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_NPRB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_NPRC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_NPRD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_NPRE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_NPRF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_NPRG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_PKRA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_PKRB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_PKRC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_PKRD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_PKRE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_PKRF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_PKRG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_TNDA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_TNDB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_TNDC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_TNDD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_TNDE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_TNDF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_TNDG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_USTA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_USTB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_USTC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_USTD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_USTE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_USTF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_USTG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_PHPA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_PHPB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_PHPC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_PHPD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_PHPE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_PHPF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_PHPG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_LAKA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_LAKB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_LAKC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_LAKD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_LAKE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_LAKF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_LAKG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_LKRA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_LKRB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_LKRC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_LKRD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_LKRE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_LKRF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_LKRG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_KHRA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_KHRB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_KHRC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_KHRD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_KHRE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_KHRF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_KHRG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_AEDA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_AEDB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_AEDC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_AEDD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_AEDE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_AEDF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_AEDG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_CADA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_CADB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_CADC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_CADD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_CADE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_CADF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_CADG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_CHFA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_CHFB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_CHFC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_CHFD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_CHFE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_CHFF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_CHFG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_DKKA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_DKKB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_DKKC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_DKKD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_DKKE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_DKKF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_DKKG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_GBPA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_GBPB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_GBPC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_GBPD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_GBPE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_GBPF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_GBPG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_MXNA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_MXNB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_MXNC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_MXND: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_MXNE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_MXNF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_MXNG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_NGNA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_NGNB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_NGNC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_NGND: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_NGNE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_NGNF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_NGNG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_NOKA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_NOKB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_NOKC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_NOKD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_NOKE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_NOKF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_NOKG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_NZDA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_NZDB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_NZDC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_NZDD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_NZDE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_NZDF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_NZDG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_RUBA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_RUBB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_RUBC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_RUBD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_RUBE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_RUBF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_RUBG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_SEKA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_SEKB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_SEKC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_SEKD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_SEKE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_SEKF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_SEKG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_TRYA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_TRYB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_TRYC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_TRYD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_TRYE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_TRYF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_TRYG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_ZARA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_ZARB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_ZARC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_ZARD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_ZARE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_ZARF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_ZARG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_COPA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_COPB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_COPC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_COPD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_COPE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_COPF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_COPG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_PENA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_PENB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_PENC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_PEND: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_PENE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_PENF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_PENG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",

    bet_limit_MNTA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_MNTB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_MNTC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_MNTD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_MNTE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_MNTF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_MNTG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",

    bet_limit_KESA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_KESB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_KESC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_KESD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_KESE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_KESF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_KESG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",

    bet_limit_PGKA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_PGKB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_PGKC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_PGKD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_PGKE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_PGKF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_PGKG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    
    bet_limit_lottery_MYRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_AUDA: "Package A (@:m.D_BIG:15 @:m.D_SMALL:15 SA:6 @:ui.min:1)",
    bet_limit_lottery_CNYA: "Package A (@:m.D_BIG:100 @:m.D_SMALL:100 SA:40 @:ui.min:2)",
    bet_limit_lottery_HKDA: "Package A (@:m.D_BIG:100 @:m.D_SMALL:100 SA:40 @:ui.min:2)",
    bet_limit_lottery_IDRA: "Package A (@:m.D_BIG:150 @:m.D_SMALL:150 SA:60 @:ui.min:3)",
    bet_limit_lottery_KRWA: "Package A (@:m.D_BIG:13000 @:m.D_SMALL:13000 SA:5000 @:ui.min:300)",
    bet_limit_lottery_SGDA: "Package A (@:m.D_BIG:15 @:m.D_SMALL:15 SA:6 @:ui.min:1)",
    bet_limit_lottery_THBA: "Package A (@:m.D_BIG:500 @:m.D_SMALL:500 SA:200 @:ui.min:10)",
    bet_limit_lottery_USDA: "Package A (@:m.D_BIG:10 @:m.D_SMALL:10 SA:5 @:ui.min:1)",
    bet_limit_lottery_VNDA: "Package A (@:m.D_BIG:250 @:m.D_SMALL:250 SA:100 @:ui.min:5)",
    bet_limit_lottery_MMKA: "Package A (@:m.D_BIG:15 @:m.D_SMALL:15 SA:6 @:ui.min:1)",
    bet_limit_lottery_MMOA: "Package A (@:m.D_BIG:15 @:m.D_SMALL:15 SA:6 @:ui.min:1)",

    bet_limit_lottery_ARSA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_BDTA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_BNDA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_BRLA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_EURA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_GOOA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_INRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_JPYA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_NPRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_PKRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_TNDA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_USTA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_PHPA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_LAKA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_LKRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_KHRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_AEDA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_CADA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_CHFA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_DKKA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_GBPA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_MXNA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_NGNA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_NOKA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_NZDA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_RUBA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_SEKA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_TRYA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_ZARA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_COPA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_PENA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_MNTA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_KESA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_PGKA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    
    comm_limit_A: "A組",
    comm_limit_B: "B組",
    comm_limit_C: "C組",
    comm_limit_D: "D組",
    comm_limit_E: "E組",
    comm_limit_F: "F組",
    comm_limit_G: "G組",
    comm_limit_H: "H組",
    comm_limit_I: "I組",
    comm_limit_J: "J組",

    comm_parlay_mmo_a: "Parlay MMO (2-3)",
    comm_parlay_mmo_b: "Parlay MMO (4-12)",

    reset_password: "@:ui.reset @:ui.password",
    edit_password: "@:ui.edit @:ui.password",
    edit_settings: "@:ui.edit @:ui.settings",
    edit_profile: "@:ui.edit @:ui.profile",
    edit_authority: "@:ui.edit @:ui.authority",
    update_commission: "@:ui.update @:ui.commission",
    update_bet_limit: "@:ui.update @:ui.bet_limit",
    update_position_taking: "@:ui.update @:ui.position_taking",
    update_profile: "@:ui.update @:ui.profile"
  },

  downline_id: "下线ID",
  disabled: "禁用",
  downline: "下线",
  dashboard: "仪表板",
  downline_list: "下线列表",
  double_chance: "双重机会",
  downline_credit: "下线信用",
  date: "日期",
  data: "数据",
  date_time: "日期/时间",
  date_range: "时间范围",
  details: "详情",
  draw: "和局",
  daily_statement: "账目",
  daily_statement_member: "会员账目",
  daily_winlose: "日常输赢",
  daily_winlose_simple: "日常输赢简略",
  daily_winlose_details: "日常输赢详情",
  daily_reset: "每日重置",
  daily_winlose_platform: "产品输赢",
  daily_winlose_match: "赛事输赢",
  detail: "详情",
  downline_outstanding: "下线未付账款",
  dd: "上半场: 和局 | 全场: 和局",
  dh: "上半场: 和局 | 全场: 主队",
  da: "上半场: 和局 | 全场: 客队",
  dnb: "平手无效",
  draw_cancel: "和局",
  default: "默认",
  deposit: "存款",

  edit: "编辑",
  enter_information: "输入信息",
  enable: "开启",
  esports: "电子竞技",
  edit_account: "编辑账号",
  edit_limit: "编辑限额",
  early: "早盘",
  event: "活动",
  enabled: "已开启",
  esports_min_bet: "@:ui.esports @:ui.min_bet",
  esports_max_bet: "@:ui.esports @:ui.max_bet",
  esports_max_per_match: "@:ui.esports @:ui.max_per_match",
  even: "偶数",
  edited: "已编辑",
  export_excel: "输出Excel",

  from: "由",
  full: "全",

  forecast: "预报",
  forecast_soccer: "预报 (足球)",
  freeze: "冻结",
  full_name: "全名",
  full_mode: "完整模式",
  first_hdp: "上半场 让球",
  first_ou: "上半场 大小",
  fh: "上半场",
  forecast_details: "预报详情",
  full_time: "全场",
  fglg: "@:m.BT_FG/@:m.BT_LG",
  first_goal: "优先得分",
  first_half: "上半场",
  fold: "串一",

  grand_total: "累计",
  gross_commission: "总佣金",
  game_name: "游戏名称",
  game_provider: "游戏供应商",
  game_result: "游戏成绩",
  game_result_details: "游戏成绩详情",
  gross_winlose: "总输赢",
  game_type: "游戏类型",
  game_rules: "老虎机规则",

  ht: "半场",
  half: "半",
  half_time: "半场",
  home: "主队",
  hdp: "让球",
  hdp_packages: "让球配套",
  home_team_name: "主队名称",
  home_score: "主队分数",
  hh: "上半场: 主队 | 全场: 主队",
  hd: "上半场: 主队 | 全场: 打和",
  ha: "上半场: 主队 | 全场: 客队",
  hdpou: "@:ui.hdp/@:ui.ou",
  htft: "@:ui.half_time/@:ui.full_time",
  hnb: "主场无效",

  ip_address: "IP 地址",
  id: "ID",

  jackpot: "大奖",

  key: "Key",
  keno: "奇乐",
  keno_bet_limit_packages: "奇乐投注限额配套",

  log_id: "记录编号",
  lottery: "彩票",
  lottery_1d: "彩票 1D",
  lottery_2d: "彩票 2D",
  lottery_3d: "彩票 3D",
  lottery_4d: "彩票 4D",
  lotto: "乐透",
  log: "日志",
  list: "列表",
  logs: "日志",
  login: "登入",
  logout: "注销",
  login_ip: "登入 IP",
  login_id: "登入 ID",
  last_name: "姓氏",
  live_casino: "真人娱乐场",
  livecasino: "真人娱乐场",
  lastweek: "上星期",
  lastmonth: "上个月",
  last3month: "3个月前",
  league_id: "联赛 ID",
  league_name: "联赛名称",
  league: "联赛",
  livecasino_platform: "真人娱乐场平台",
  livecasino_upline_pt : "@:ui.live_casino @:ui.upline_pt",
  livecasino_account_pt : "@:ui.live_casino @:ui.account_pt",
  livecasino_upline_remaining : "@:ui.live_casino @:ui.upline_remaining",
  livecasino_account_min : "@:ui.live_casino @:ui.account_min",
  livecasino_bet_limit_packages: "真人娱乐场投注限额配套",
  last_goal: "最后得分",
  live: "直播",
  lose: "输",
  lose_half: "输半",
  last_week: "上星期",
  last_month: "上个月",
  lotto_bet_limit_packages: "乐透投注限额配套",
  lottery_bet_limit_packages: "彩票投注限额配套",

  member_log: "会员日志",
  member_balance: "会员余额",
  master_credit: "总代理信用",
  member_credit_limit: "总代理信用限额",
  max_credit_limit: "最高信用限额",
  min_max_bet: "最低/最高 单注",
  min_bet: "最低单注",
  max_bet: "最高单注",
  max_per_match: "单场限额",
  mix_parlay: "混合过关",
  mmo_parlay: "缅甸混合过关",
  money_line: "独赢",
  min: "最低",
  max: "最高",
  market_type: "市场类型",
  match_time: "赛事时间",
  match_id: "赛事 ID",
  member_id: "用户名",
  match: "赛事",
  master_outstanding: "总代理未付账款",
  mode: "模式",
  member_outstanding: "会员未付账款",
  member_outstanding_4d: "会员未付账款 4D",
  match_result: "赛事成绩",
  messages: "个人信息",
  message: "信息",
  member_management: "会员管理",
  member_bulk: "会员（批量）",
  manila_nocomm: "Game Play & Pretty Gaming & Evolution & Pragmatic & Sexy Gaming Livecasino 0% 佣金",
  m4d: "4D",
  marketing_tools: "营销工具",
  min_credit: "最低信用额",

  new: "新",
  new_login_id: "新登入ID",
  new_username: "新用户名",
  new_password: "新密码",
  new_security_code: "新安全码",
  new_account: "新账号",
  next: "下页",
  no_goal: "无进球",
  "no/": "No.",
  normal: "正常",
  normal_announcements: "一般公告",

  on: "开",
  off: "关",
  ok: "确定",
  over: "大",
  overview: "概览",
  old_password: "旧密码",
  outstanding: "未付款项(欠款）" ,
  outstanding_balance: "未付款项(欠款）",
  over_under: "大小",
  odd_even: "单双",
  ou: "大小",
  oe: "单双",
  others: "其他",
  odd: "单",
  oxt: "独赢",
  outright: "总冠军",
  others_min_bet: "@:ui.others @:ui.min_bet",
  others_max_bet: "@:ui.others @:ui.max_bet",
  others_max_per_match: "@:ui.others @:ui.max_per_match",
  odds_display: "赔率显示",
  online_player: "在线玩家",
  opening_balance: "期初余额",
  oxtoeml: "@:m.BT_OE/@:m.BT_1X2/@:m.BT_ML",
  oxthdp: "让球独赢",
  others_sports: "其他球类",

  pending: "待定",
  platform: "平台",
  pt: "持仓",
  password: "密码",
  profile_id: "简介ID",
  parent_id: "主级ID",
  page_size: "页数",
  profile: "个人资料",
  payment_option: "付款选项",
  part_one: "第一章",
  part_two: "第二章",
  position_taking: "持仓",
  preview_settings: "预览设置",
  preview: "预览",
  parlay: "连带",
  position_taking_log: "持仓日志",
  platform_code: "平台代码",
  platform_name: "平台名称",
  pay: "付款 | 全额付款",
  payout: "支付",
  product: "产品",
  pending_matches: "待定赛事",
  pt_share: "持仓份额",
  platform_settings: "平台设定",
  parlay_min_bet: "@:ui.parlay @:ui.min_bet",
  parlay_max_bet: "@:ui.parlay @:ui.max_bet",
  parlay_max_per_match: "@:ui.parlay @:ui.max_per_match",
  parlay_upline_pt : "@:ui.parlay @:ui.upline_pt",
  parlay_account_pt : "@:ui.parlay @:ui.account_pt",
  parlay_upline_remaining : "@:ui.parlay @:ui.upline_remaining",
  parlay_account_min : "@:ui.parlay @:ui.account_min",
  parlay_mmo_upline_pt : "Parlay MMO @:ui.upline_pt",
  parlay_mmo_account_pt : "Parlay MMO @:ui.account_pt",
  parlay_mmo_upline_remaining : "Parlay MMO @:ui.upline_remaining",
  parlay_mmo_account_min : "Parlay MMO @:ui.account_min",
  personal: "个人",
  personal_message: "个人信息",
  password_reset: "重设密码",
  password_update: "密码更新",

  refresh: "刷新",
  reset: "重置",
  remaining_credit: "保留信用",
  remaining: "保留",
  rate: "估价",
  report: "报告",
  running: "滚球",
  remark: "备注",
  refund: "退款",
  range: "范围",
  reject: "拒绝",
  reset_accumulate_win: "重置累积赢盘",
  refno: "参考编号",
  result: "成绩",
  room_1: "公共",
  room_2: "私人",
  room_3: "公共（免费）",

  status: "状态",
  succeed: "成功",
  submit: "提交",
  settings: "设置",
  save: "保存",
  search: "搜索",
  suspend: "暂停",
  security_tag: "安全标签",
  sub_account: "子账号",
  search_and_copy: "搜索与复制",
  search_existing: "搜索存在",
  skip: "跳过",
  settings_limit: "限额设置",
  sportsbook: "体育博彩",
  slot_games: "老虎机游戏",
  soccer: "足球",
  sport_types: "运动类型",
  settlement: "结算",
  submatch_id: "子赛事ID",
  score: "分数",
  submatch_code: "子赛事代码",
  settlement_list: "结算清单",
  sub_total: "小计",
  settle_amount: "结算金额",
  settlement_history: "结算历史",
  // settlement_member: "会员结算详情",
  sport_type: "运动类型",
  slot_platform: "老虎机平台",
  simple_report: "简略报告",
  status_update: "更新状态",
  set_authority: "设置权限",
  soccer_hdp_upline_pt : "@:ui.soccer @:ui.hdp @:ui.upline_pt",
  soccer_hdp_account_pt : "@:ui.soccer @:ui.hdp @:ui.account_pt",
  soccer_hdp_upline_remaining : "@:ui.soccer @:ui.hdp @:ui.upline_remaining",
  soccer_hdp_account_min : "@:ui.soccer @:ui.hdp @:ui.account_min",
  soccer_1x2_upline_pt : "@:ui.soccer @:ui.oxt @:ui.upline_pt",
  soccer_1x2_account_pt : "@:ui.soccer @:ui.oxt @:ui.account_pt",
  soccer_1x2_upline_remaining : "@:ui.soccer @:ui.oxt @:ui.upline_remaining",
  soccer_1x2_account_min : "@:ui.soccer @:ui.oxt @:ui.account_min",
  soccer_others_upline_pt : "@:ui.soccer @:ui.others @:ui.upline_pt",
  soccer_others_account_pt : "@:ui.soccer @:ui.others @:ui.account_pt",
  soccer_others_upline_remaining : "@:ui.soccer @:ui.others @:ui.upline_remaining",
  soccer_others_account_min : "@:ui.soccer @:ui.others @:ui.account_min",
  hdp_mmo_upline_pt : "@:ui.hdp MMO @:ui.upline_pt",
  hdp_mmo_account_pt : "@:ui.hdp MMO @:ui.account_pt",
  hdp_mmo_upline_remaining : "@:ui.hdp MMO @:ui.upline_remaining",
  hdp_mmo_account_min : "@:ui.hdp MMO @:ui.account_min",
  slots_upline_pt : "@:ui.slots @:ui.upline_pt",
  slots_account_pt : "@:ui.slots @:ui.account_pt",
  slots_upline_remaining : "@:ui.slots @:ui.upline_remaining",
  slots_account_min : "@:ui.slots @:ui.account_min",
  soccer_min_bet: "@:ui.soccer @:ui.min_bet",
  soccer_max_bet: "@:ui.soccer @:ui.max_bet",
  soccer_max_per_match: "@:ui.soccer @:ui.max_per_match",
  slots: "老虎机",
  security_update: "更新安全性",
  security_code: "安全码",
  success: "成功",
  stock: "库存",
  special: "特殊",
  special_announcements: "特别公告",
  seconds: "秒",
  security_disable: "安全性禁用",
  select_all: "全选",
  system_parlay: "串关系统",
  settlement_agent_bulk: "批量结算代理",
  settlement_agent: "结算代理",
  settle_agent: "结算代理",
  settlement_member_bulk: "批量结算会员",
  settlement_member: "结算会员",
  settle_member: "结算会员",

  schedule_1: "星期一 | 一",
  schedule_2: "星期二 | 二",
  schedule_3: "星期三 | 三",
  schedule_4: "星期四 | 四",
  schedule_5: "星期五 | 五",
  schedule_6: "星期六 | 六",
  schedule_7: "星期日 | 日",

  twtn: "零失球的胜方",
  total_outstanding: "总未付账单(欠款）",
  target_id: "目标ID",
  target_action: "目标操作",
  total: "总计",
  types: "类型",
  total_goal: "总门球",
  tennis: "网球",
  today: "今天",
  thisweek: "本周",
  thismonth: "本月",
  transaction_log: "交易日志",
  total_bet: "总投注",
  transaction_date: "交易日期/时间",
  transfer_method: "汇款方式",
  turnover: "流动率",
  total_balance: "总余额",
  total_tran: "总交易",
  total_base: "会员总投注",
  tennis_min_bet: "@:ui.tennis @:ui.min_bet",
  tennis_max_bet: "@:ui.tennis @:ui.max_bet",
  tennis_max_per_match: "@:ui.tennis @:ui.max_per_match",
  top_winner: "本月十大优胜者",
  top_turnover: "本月十大营业额",
  top_loser: "本月十大輸家",
  type: "类型",
  total_downline: "总下线",
  to: "至",
  transfer: "汇款",
  transfer_list: "汇款清单",
  transfer_history: "汇款历史",
  this_month: "本月",
  this_week: "本周",
  total_accepted: "总接受",
  total_rejected: "总拒绝",
  total_stake: "总赌金",
  total_winlose: "总输/输",
  total_member: "总成员",
  tournament: "锦标赛",
  tournament_jackpot: "锦标赛大奖",
  tournament_refund_list: "锦标赛退款列表",

  under: "小",
  upline_id: "上线ID",
  unblock: "解封",
  update: "更新",
  username: "用户名",
  update_commission_sb: "体育博彩佣金",
  update_commission_lc: "真人娱乐场佣金",
  update_commission_sl: "老虎机佣金",
  update_commission_lo: "乐透佣金",
  update_commission_kn: "奇乐佣金",
  update_commission_cf: "斗鸡佣金",
  update_commission_lt: "彩票佣金",
  update_bet_limit_lc: "真人娱乐场投注限额",
  update_bet_limit_sb: "体育博彩投注限额",
  update_bet_limit_lo: "乐透投注限额",
  update_bet_limit_kn: "奇乐投注限额",
  update_bet_limit_cf: "斗鸡投注限额",
  update_bet_limit_lt: "彩票投注限额",
  update_position_sb: "体育博彩PT(持仓）",
  update_position_lc: "真人娱乐场PT(持仓）",
  update_position_sl: "老虎机PT(持仓）",
  update_position_lo: "乐透PT(持仓）",
  update_position_kn: "奇乐PT(持仓）",
  update_position_cf: "斗鸡PT(持仓）",
  update_position_lt: "彩票PT(持仓）",
  update_account: "更新账号",
  update_platform: "更新平台",
  upline_pt: "上线PT（持仓）",
  upline_remaining: "上线保留",
  unblock_profile: "解封个人资料",
  unselect_all: "全部取消",

  view_details: "查看详情",
  view_downline: "查看下线",
  value: "价值",
  valid_turnover: "活跃流动率",
  void: "废止",

  winlose_limit: "输赢限制",
  wallet: "钱包",
  winlose: "输赢",
  win_limit: "赢额限制",
  win_limit_multiplier: "赢额限制倍数",
  win_limit_tooltips: "仅适用于真人娱乐场。",
  win_limit_tooltips1:" 由于真人娱乐场应用程序编程接口的延迟，玩家可能会在达到赢额限制之后继续下注几分钟。",
  win_limit_0: "无限额",
  win_limit_1: "信用限额 x 1倍",
  win_limit_2: "信用限额 x 2倍",
  win_limit_5: "信用限额 x 5倍",
  win_limit_10: "信用限额 x 10倍",
  win_limit_20: "信用限额 x 20倍",
  winlose_column1: "输赢",
  winlose_column2: "佣金",
  winlose_today: "今日输赢",
  winlose_yesterday: "昨日输赢",
  winner: "优胜者",
  won: "赢",
  win_half: "赢半",
  withdrawal: "提款",

  yesterday: "昨日",
  yesterday_balance: "昨日余额",

  provider_evo: "Evolution",
  provider_gp: "Game Play",
  provider_vivo: "Vivo suite",
  provider_sa: "SA Gaming",
  provider_ct: "CT855",
  provider_ptg: "Pretty Gaming",
  provider_yb: "Yeebet",
  "provider_pp-c": "Pragmatic",
  provider_lotto: "乐透",
  provider_keno: "奇乐",
  provider_cockfight: "电子竞技2",
  provider_lottery: "彩票",
  provider_ar: "Arcadia Gaming",
  provider_slots: "老虎机 (Live22)",
  provider_pgs: "老虎机 (PGSoft)",
  provider_pp: "老虎机 (PP)",
  provider_jk: "老虎机 (Joker)",
  provider_sp: "老虎机 (SimplePlay)",
  provider_jili: "老虎机 (Jili)",
  provider_uu: "老虎机 (UU)",
  provider_db: "老虎机 (DBHash)",
  provider_wow: "老虎机 (WOW Gaming)",
  provider_ai: "AI Livecasino",
  provider_wf: "老虎机 (WF Gaming)",
  provider_next: "老虎机 (Next)",
  provider_dbp: "老虎机 (DBHash)",
  provider_epw: "老虎机 (Epicwin)",
  provider_sexybcrt: "Sexy Baccarat",

  timer: "计时器",
  no_refresh: "没有刷新",
  actual_yesterday_balance: "实际昨日余额",
  
  loading: "加载中...",
  slide_puzzle: "滑动拼图",
  drag_to_verify: "拖动验证",
  running_score: "比分",
  unblock_account: "解锁账户",
  password_expired: "密码已过期",

  lotto_upline_pt : "@:ui.lotto @:ui.upline_pt",
  lotto_account_pt : "@:ui.lotto @:ui.account_pt",
  lotto_upline_remaining : "@:ui.lotto @:ui.upline_remaining",
  lotto_account_min : "@:ui.lotto @:ui.account_min",
  keno_upline_pt : "@:ui.keno @:ui.upline_pt",
  keno_account_pt : "@:ui.keno @:ui.account_pt",
  keno_upline_remaining : "@:ui.keno @:ui.upline_remaining",
  keno_account_min : "@:ui.keno @:ui.account_min",
  cockfight_upline_pt : "@:ui.cockfight @:ui.upline_pt",
  cockfight_account_pt : "@:ui.cockfight @:ui.account_pt",
  cockfight_upline_remaining : "@:ui.cockfight @:ui.upline_remaining",
  cockfight_account_min : "@:ui.cockfight @:ui.account_min",
  lottery_upline_pt : "@:ui.lottery @:ui.upline_pt",
  lottery_account_pt : "@:ui.lottery @:ui.account_pt",
  lottery_upline_remaining : "@:ui.lottery @:ui.upline_remaining",
  lottery_account_min : "@:ui.lottery @:ui.account_min",
};
